export const locale = {
    lang: "es",
    data: {
        MYORDERS: {
            MYORDERS: "Órdenes de trabajo",
        },
        MYOOTT: {
            MYOOTT: "Órdenes de Trabajo",
        },
    },
};
